import { render, staticRenderFns } from "./MenuItemGroup.vue?vue&type=template&id=b1b2fc22&"
import script from "./MenuItemGroup.vue?vue&type=script&lang=js&"
export * from "./MenuItemGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports